let PackagesItem = [
    {
        track_mode: `junior`,
        track_title: `Junior Day`,
        track_desc: `[ Entry-level ]`,
        track_talks: `10+`,
        track_option_1: true,
        track_option_2: false,
        track_option_3: false,
        track_option_4: false,
        track_option_5: false,
        track_option_6: false,
        track_option_7: false,
        track_price_full: `Free`,
        track_price: `$0`,
        track_button: `Register`,
        track_button_desc: `[ 100 spots left ]`,
        track_link: `https://geekle.us/ticketfree/1696332491817x773045352073789400`
    },
    {
        track_mode: `senior`,
        track_title: `Senior Day`,
        track_desc: `[ Deep-level ]`,
        track_talks: `20+`,
        track_option_1: true,
        track_option_2: true,
        track_option_3: true,
        track_option_4: true,
        track_option_5: true,
        track_option_6: false,
        track_option_7: false,
        track_price_full: `$500`,
        track_price: `$199`,
        track_button: `Register`,
        track_button_desc: ``,
        track_link: `https://geekle.us/ticket/1726749092047x339542239733088260`
    },
    {
        track_mode: `year`,
        track_title: `Year of UI/UX`,
        track_desc: `[ Most Popular ]`,
        track_talks: `ALL`,
        track_option_1: true,
        track_option_2: true,
        track_option_3: true,
        track_option_4: true,
        track_option_5: true,
        track_option_6: true,
        track_option_7: true,
        track_price_full: `$1000`,
        track_price: `$299`,
        track_button: `Register`,
        track_button_desc: ``,
        track_link: `https://geekle.us/ticket/1726749030959x498383458725527550`
    },
    
];

export default PackagesItem;
